import { NotificationSubscriptionEdit } from "./NotificationSubscriptionEdit";
import { NotificationSubscriptionCreate } from "./NotificationSubscriptionCreate";
import NotificationsOutlinedIcon from "@material-ui/icons/NotificationsOutlined";
import { NotificationSubscriptionsList } from "./NotificationSubscriptionsList";

export default {
  icon: NotificationsOutlinedIcon,
  list: NotificationSubscriptionsList,
  create: NotificationSubscriptionCreate,
  edit: NotificationSubscriptionEdit,
};
